import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges} from '@angular/core';
import {CommonModule, NgComponentOutlet} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import {BadgeComponent} from "../badge";
import {Field, LookupEvent, LookupField, LookupKind} from "./index";
import {MultiItemHoverComponent} from "../multi-item-hover/multi-item-hover.component";
import {ClipboardComponent} from "../clipboard/clipboard.component";
import {ActivatedRoute, Route, Router, RouterLink} from "@angular/router";
import {Batch, BatchRpcService, DocumentRpcService, getStatusOptions, StatusOptions} from "@alpha/services";
import {Helpers} from "../helpers";
import {Document} from "../document-list-item";

@Component({
  selector: 'lookup-item',
  standalone: true,
  imports: [CommonModule, BadgeComponent, MultiItemHoverComponent, ClipboardComponent, NgComponentOutlet, RouterLink],
  templateUrl: './lookup-item.component.html',
  styleUrls: ['./lookup-item.component.scss']
})
export class LookupItemComponent implements OnInit, OnChanges {

  @Input() details: boolean = false;
  @Input() document: boolean = true;
  @Input() documents: Document[] = [];

  @Input() identifier: string | undefined;
  @Input() criteria: string | undefined;

  id: string | undefined;

  @Input() fields: Field[] = [];
  parsed_fields: LookupField[] = [];

  @Input() data: any | undefined;
  @Input() header: LookupField | undefined;
  @Output() change: EventEmitter<LookupEvent>;

  status: StatusOptions = getStatusOptions(0);

  constructor(private ds: DocumentRpcService, private bs:BatchRpcService, public route: ActivatedRoute) {
    this.change = new EventEmitter<LookupEvent>();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.parseFields();
      this.status = getStatusOptions(parseInt(this.data.status));
      if (this.data.documents) {
        this.documents = this.data.documents;
      }
    }
  }

  ngOnInit() {
    this.parseFields();
    this.status = getStatusOptions(parseInt(this.data.status));
  }

  async toggleBookmark(data:Batch) {
    data.bookmarked = !data.bookmarked;
    if(this.id){
      await this.bs.bookmark(this.id);
    }
    this.change.emit({kind: LookupKind.Bookmark, event: {identifier: this.identifier}})
  }

  async print() {
    if (this.id && this.documents.length > 0) {
      const ids = this.documents.map(d => d.did);
      const download = await this.ds.getDocumentDownload(this.id, ids);
      if (download) {
        const ext = (this.documents.length > 1) ? 'zip' : this.documents[0]!.ext;
        Helpers.downloadData(download, new Date().toISOString() + '.' + ext, ext);
      }
      this.change.emit({kind: LookupKind.Print, event: {identifier: this.identifier}})
    }
  }

  parseFields() {
    this.parsed_fields = [];

    if (this.identifier) {
      this.id ??= this.data[this.identifier];
    }
    this.fields.sort(function (a, b) {
      if (a.label< b.label) {
        return -1;
      }
      if (a.label> b.label) {
        return 1;
      }
      return 0;
    }).forEach((field)=>{
      let value;
      if(field.component?.name == 'MultiItemHoverComponent'){
        value = this.data[field.identifier] ?? [];
      }else{
        value = this.data[field.identifier];
      }

      this.parsed_fields.push({
        label: field?.label ?? '',
        value: field?.pipe ? field.pipe.transform(value) : value,
        component: field?.component
      })
    })

    // Object.keys(this.data).forEach((field_identifier) => {
    //   const field = this.fields.find(f => f.identifier == field_identifier)!;
    //   console.log(field, field_identifier)
    //   // if (field?.label) {
    //     const value = this.data[field?.identifier];
    //     if (value && value.length > 0) {
    //       this.parsed_fields.push({
    //         label: field?.label ?? '',
    //         value: field?.pipe ? field.pipe.transform(value) : value,
    //         component: field?.component
    //       })
    //     }
    //   // }
    // });
  }
}

